var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"conf"},[_c('h1',{staticClass:"tms-title"},[_vm._v("BASIC")]),_c('div',{staticClass:"m-x-24 mt-md-4"},[_c('BasicTimeZone')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }